export default "__VITE_ASSET__1fc002a4__"